import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Swal from 'sweetalert2';
import logoImg from '@/assets/img/fondotam-blanco.png';
/* eslint-disable */
// ─── PALETA CORPORATIVA TAMEP ─────────────────────────────────────────────────
const AZUL_OSCURO = [0, 51, 102];   // #003366
const AZUL_MEDIO = [26, 82, 157];   // #1a529d
const AZUL_CLARO = [180, 198, 231];   // #b4c6e7
const AZUL_SUPER = [220, 230, 242];   // #dce6f2
const GRIS_ENCABEZ = [64, 64, 64];
const BLANCO = [255, 255, 255];
const NEGRO = [0, 0, 0];
const ROJO_ALERTA = [192, 0, 0];
const VERDE_BIEN = [0, 112, 44];
const AMARILLO_REG = [150, 110, 0];

// ─── HELPERS ──────────────────────────────────────────────────────────────────

/** Color del estado físico */
function colorEstado(estado) {
  if (!estado) return NEGRO;
  const e = estado.toLowerCase();
  if (e === 'bueno') return VERDE_BIEN;
  if (e === 'regular') return AMARILLO_REG;
  if (e === 'malo') return ROJO_ALERTA;
  return NEGRO;
}

/** Color de la situación */
function colorSituacion(situacion) {
  if (!situacion) return NEGRO;
  const s = situacion.toLowerCase();
  if (s === 'asignado') return VERDE_BIEN;
  if (s === 'disponible') return AZUL_MEDIO;
  if (s === 'mantenimiento') return AMARILLO_REG;
  if (s === 'baja') return ROJO_ALERTA;
  return NEGRO;
}

// ─── REPORTE PRINCIPAL ────────────────────────────────────────────────────────

export const generarReportePDF = (activosList, datosAsignacion, setExportando) => {
  if (!activosList || activosList.length === 0) {
    return Swal.fire('Sin datos', 'No hay activos para exportar.', 'info');
  }
  if (setExportando) setExportando(true);

  try {
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'letter' });
    const PW = doc.internal.pageSize.getWidth();   // 215.9 mm
    const PH = doc.internal.pageSize.getHeight();  // 279.4 mm
    const ML = 14;   // margen izquierdo
    const MR = 14;   // margen derecho
    const CW = PW - ML - MR; // ancho útil (187.9 mm)

    // Paleta Verde Corporativa EPTAM
    const VERDE_TAMEP = [0, 150, 80];   // #009650
    const NEGRO = [0, 0, 0];
    const BLANCO = [255, 255, 255];
    const GRIS_TEXTO = [80, 80, 80];

    const fechaHoy = datosAsignacion?.fechaRecepcion || new Date().toLocaleDateString('es-BO');
    const nroActa = datosAsignacion?.nroActa || 'GAA.J.ADM. SECC.ACT.FIJOS EP.TAM. N° ____ / ____';
    const responsable = datosAsignacion?.responsable || '';
    const entregadoPor = datosAsignacion?.entregadoPor || '';
    const ciudad = datosAsignacion?.ciudad || '________________';
    const unidad = datosAsignacion?.unidad || datosAsignacion?.gerencia || '________________';

    let pageNum = 1;

    const dibujarEncabezado = (page) => {
      // 1. Número de Acta arriba a la derecha (solo en la primera página)
      if (page === 1) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8.5);
        doc.setTextColor(...NEGRO);
        doc.text(nroActa, PW - MR, 12, { align: 'right' });
      }

      // 2. Logo TAMEP a la derecha
      if (logoImg) {
        doc.addImage(logoImg, 'PNG', PW - MR - 45, 14, 45, 18);
      }

      // 3. Membrete EPTAM arriba a la izquierda
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.setTextColor(...NEGRO);
      doc.text('EPTAM', ML, 13);
      doc.setFontSize(9);
      doc.text('Empresa Pública', ML, 17);
      doc.text('Transporte Aéreo Militar', ML, 21);
      doc.text('Sección de Activos Fijos', ML, 25);

      // 4. Banner Principal Verde: ACTA DE ENTREGA DE ACTIVOS FIJOS
      const bannerY = 32;
      doc.setFillColor(...VERDE_TAMEP);
      doc.rect(ML, bannerY, CW, 7, 'F');
      doc.setDrawColor(...NEGRO);
      doc.setLineWidth(0.2);
      doc.rect(ML, bannerY, CW, 7, 'S');

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.setTextColor(...BLANCO);
      doc.text('ACTA DE ENTREGA DE ACTIVOS FIJOS', PW / 2, bannerY + 4.8, { align: 'center' });
    };

    // Dibujar primera cabecera
    dibujarEncabezado(pageNum);

    let cursorY = 40;

    // ── 2. CUADRO DE DATOS DE ASIGNACIÓN / ENTREGA ───────────────────────────
    autoTable(doc, {
      startY: cursorY,
      margin: { left: ML, right: MR, top: 40, bottom: 20 },
      theme: 'grid',
      body: [
        [
          { content: 'Entregado al Señor (a):', styles: { fontStyle: 'bold', cellWidth: 35 } },
          { content: responsable, styles: { fontStyle: 'bold', cellWidth: 82 } },
          { content: 'Fecha de Recepción :', styles: { fontStyle: 'bold', cellWidth: 35 } },
          { content: fechaHoy, styles: { halign: 'center', fontStyle: 'bold' } },
        ],
        [
          { content: 'Entregado por:', styles: { fontStyle: 'bold', cellWidth: 35 } },
          { content: entregadoPor, colSpan: 3, styles: { fontStyle: 'bold' } },
        ],
        [
          {
            content: `En la ciudad de ${ciudad}, en la unidad de ${unidad}, se procedió a la entrega y recepción de Activos Fijos para su custodia/reparación bajo el siguiente detalle:`,
            colSpan: 4,
            styles: { fontSize: 7.5, fontStyle: 'normal', cellPadding: 2.5 }
          }
        ]
      ],
      styles: {
        fontSize: 8,
        textColor: NEGRO,
        lineColor: NEGRO,
        lineWidth: 0.25,
        cellPadding: { top: 2, bottom: 2, left: 3, right: 3 }
      }
    });

    cursorY = doc.lastAutoTable.finalY + 4;

    // ── 3. TABLA PRINCIPAL DE ACTIVOS CON ENCABEZADO VERDE ───────────────────
    const HEAD = [['N°', 'CÓDIGO', 'DESCRIPCIÓN', 'CONDICIÓN', 'SITUACIÓN']];

    const bodyActivos = activosList.map((a, idx) => {
      // Códigos en líneas separadas (Código TAMEP actual arriba, Código TAB histórico abajo)
      const codigos = [a.codigo_tamep, a.codigo_tab].filter(Boolean);
      const codigo = codigos.length > 0 ? codigos.join('\n') : 'S/C';

      // Descripción completa: Título (nombre_especifico) + Descripción
      const partes = [];
      if (a.nombre_especifico && a.nombre_especifico.trim()) {
        partes.push(a.nombre_especifico.trim());
      }
      if (a.descripcion && a.descripcion.trim()) {
        const desc = a.descripcion.trim();
        if (!a.nombre_especifico || desc.toUpperCase() !== a.nombre_especifico.trim().toUpperCase()) {
          partes.push(desc);
        }
      }
      let descrip = partes.join(' - ');

      // Si tiene número de serie (activos tecnológicos u otros), se agrega su SN
      if (a.serie && a.serie.trim() && a.serie.trim().toUpperCase() !== 'S/N') {
        descrip += ` N° serie: ${a.serie.trim()}`;
      }

      const condicion = (a.estado_actual || 'REGULAR').toUpperCase();
      const situacion = (a.situacion_activo || 'DISPONIBLE').toUpperCase();

      return [
        idx + 1,
        codigo,
        descrip || 'SIN DETALLE',
        condicion,
        situacion
      ];
    });

    autoTable(doc, {
      startY: cursorY,
      margin: { left: ML, right: MR, top: 40, bottom: 20 },
      theme: 'grid',
      head: HEAD,
      body: bodyActivos,
      styles: {
        fontSize: 7.5,
        textColor: NEGRO,
        lineColor: NEGRO,
        lineWidth: 0.25,
        cellPadding: 2.5,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: VERDE_TAMEP,
        textColor: BLANCO,
        fontStyle: 'bold',
        fontSize: 8,
        halign: 'center',
        lineColor: NEGRO,
        lineWidth: 0.25
      },
      columnStyles: {
        0: { halign: 'center', cellWidth: 10, fontStyle: 'bold' },
        1: { halign: 'center', cellWidth: 35, fontStyle: 'bold' },
        2: { halign: 'left', cellWidth: 85 },
        3: { halign: 'center', cellWidth: 28 },
        4: { halign: 'center', cellWidth: 29.9 }
      },
      didDrawPage: (data) => {
        if (data.pageNumber > pageNum) {
          pageNum = data.pageNumber;
          dibujarEncabezado(pageNum);
        }
      }
    });

    cursorY = doc.lastAutoTable.finalY + 5;

    // ── 4. PARÁGRAFO LEGAL (LEY N° 1178) Y NOTA DE CONFORMIDAD ─────────────
    const altoParagrafoYFirmas = 75;
    if (cursorY + altoParagrafoYFirmas > PH - 15) {
      doc.addPage();
      pageNum++;
      dibujarEncabezado(pageNum);
      cursorY = 42;
    }

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6.8);
    doc.setTextColor(...NEGRO);

    const textoLey1178 = "El servidor público queda prohibido de usar o permitir el uso de los bienes para beneficio particular o privado, prestar o transferir el bien a otro empleado público, enajenar el bien por cuenta propia, dañar o alterar sus características físicas o técnicas, poner en riesgo el bien, ingresar o sacar bienes particulares sin autorización de la Unidad o Responsable de Activos Fijos. La no observancia a estas prohibiciones generará responsabilidades establecidas en la Ley N° 1178 y sus reglamentos.";

    const lineasLey = doc.splitTextToSize(textoLey1178, CW);
    doc.text(lineasLey, ML, cursorY);
    cursorY += (lineasLey.length * 3) + 4;

    // Nota de conformidad
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text('En señal de conformidad y aceptación se firma la presente acta.', ML, cursorY);
    cursorY += 12;

    // ── 5. BLOQUE DE 4 FIRMAS ESTÁTICAS (GRILLA 2X2) ─────────────────────────
    const anchoFirma = 65;
    const centroCol1 = ML + 40;
    const centroCol2 = PW - MR - 40;

    // FILA 1 DE FIRMAS (Arriba)
    const yFiltro1 = cursorY + 12;

    // Linea Firma 1 (Encargado de Activos Fijos)
    doc.setDrawColor(...NEGRO);
    doc.setLineWidth(0.4);
    doc.line(centroCol1 - (anchoFirma / 2), yFiltro1, centroCol1 + (anchoFirma / 2), yFiltro1);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text('ENTREGUE CONFORME:', centroCol1, yFiltro1 + 4, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6.8);
    doc.text('Encargado de Activos Fijos', centroCol1, yFiltro1 + 7.5, { align: 'center' });

    // Linea Firma 2 (Recibí Conforme - Custodio)
    doc.line(centroCol2 - (anchoFirma / 2), yFiltro1, centroCol2 + (anchoFirma / 2), yFiltro1);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text('RECIBI CONFORME:', centroCol2, yFiltro1 + 4, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6.8);
    doc.text(responsable, centroCol2, yFiltro1 + 7.5, { align: 'center' });

    // FILA 2 DE FIRMAS (Abajo)
    const yFiltro2 = yFiltro1 + 22;

    // Linea Firma 3 (Jefe de Asuntos Administrativos)
    doc.line(centroCol1 - (anchoFirma / 2), yFiltro2, centroCol1 + (anchoFirma / 2), yFiltro2);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text('V.B.:', centroCol1, yFiltro2 + 4, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6.8);
    doc.text('Jefe de Asuntos Administrativos', centroCol1, yFiltro2 + 7.5, { align: 'center' });

    // Linea Firma 4 (Gerente de Asuntos Administrativos)
    doc.line(centroCol2 - (anchoFirma / 2), yFiltro2, centroCol2 + (anchoFirma / 2), yFiltro2);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text('AUTORIZADO POR:', centroCol2, yFiltro2 + 4, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6.8);
    doc.text('Gerente de Asuntos Administrativos', centroCol2, yFiltro2 + 7.5, { align: 'center' });

    // ── 6. PIE DE PÁGINA ──────────────────────────────────────────────────────
    const totalPaginas = doc.internal.getNumberOfPages();
    for (let p = 1; p <= totalPaginas; p++) {
      doc.setPage(p);
      doc.setDrawColor(200);
      doc.setLineWidth(0.2);
      doc.line(ML, PH - 12, PW - MR, PH - 12);

      doc.setFont('helvetica', 'italic');
      doc.setFontSize(6.5);
      doc.setTextColor(...GRIS_TEXTO);
      doc.text(
        'Documento generado por el Sistema Integral de Gestión de Activos Fijos (SIGAF) - EPTAM',
        PW / 2, PH - 8, { align: 'center' }
      );
      doc.text(
        `Pág. ${p} de ${totalPaginas}`, PW - MR, PH - 8, { align: 'right' }
      );
    }

    // ── 7. GUARDAR ARCHIVO PDF ────────────────────────────────────────────────
    const nombreFirma = responsable ? responsable.replace(/\s+/g, '_') : 'Acta';
    const fecha = new Date().toISOString().split('T')[0];
    doc.save(`EPTAM_Acta_Entrega_${nombreFirma}_${fecha}.pdf`);

  } catch (error) {
    console.error('PDF ERROR:', error);
    Swal.fire('Error', 'No se pudo generar el PDF. Revisa la consola.', 'error');
  } finally {
    if (setExportando) setExportando(false);
  }
};

// ─── EXPORTACIÓN CSV ─────────────────────────────────────────────────────────

export const generarReporteCSV = (activosList) => {
  if (activosList.length === 0) {
    return Swal.fire('Sin datos', 'No hay activos para exportar.', 'info');
  }

  const headers = [
    'N°', 'Código Actual', 'Código Histórico', 'Descripción', 'Regional',
    'Ubicación', 'Responsable', 'Cargo', 'Situación', 'Estado Físico',
    'Perfil Uso', 'Estado IA', 'Prob. Falla (%)'
  ];

  const rows = activosList.map((a, i) => [
    i + 1,
    a.codigo_tamep || '',
    a.codigo_tab || '',
    a.nombre_especifico,
    a.regional_nombre || '',
    a.ubicacion_nombre || '',
    a.custodio_nombre || 'Sin asignar',
    a.cargo_nombre || '',
    a.situacion_activo,
    a.estado_actual,
    a.perfil_uso || '',
    a.estado_ia || '',
    a.probabilidad_falla != null ? a.probabilidad_falla.toFixed(1) : ''
  ]);

  const csv = [headers.join(';'), ...rows.map(r => r.join(';'))].join('\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `TAMEP_Inventario_${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};